export default function StatBox({ number, label }) {
    return (
      <div className="text-center">
        <div className="text-3xl font-bold text-yellow-500 mb-1">{number}</div>
        <div className="text-gray-700 font-medium">{label}</div>
      </div>
    );
  }